import styled from "styled-components";

export const Input: any = styled.input`
  width: 100%;
  border: none;
  border-bottom: 1px solid #fff;
  opacity: 0.7;
  background: rgba(0, 0, 0, 0);
  color: #fff;
  font-size: 1.4vw;
  letter-spacing: 0.15vw;
  user-select: initial;
`;
